import * as BaseAPI from '@/api/baseAPI';
import User from "../../../shared/models/user";

export async function getLoggedInUser(): Promise<User> {
  const result = await BaseAPI.simpleGet(`/user`);
  return result.data;
}